import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { RareSkeletonsQuestiontypes } from './RareSkeletonsQuestiontypes';
import { RareSkeletonsLibs } from './RareSkeletonsLibs';
import { RareSkeletonsVisibleVideo } from './RareSkeletonsVisibleVideo';
import { RareSkeletonsVisibleSound } from './RareSkeletonsVisibleSound';
import { RareSkeletonsQuestion } from './RareSkeletonsQuestion';
export class RareSkeletons extends SkeletonRegistryCategory {
    label = 'Rare';
    constructor(parent) {
        super(parent);
    }
    c_v = new RareSkeletonsVisibleVideo(this);
    c_s = new RareSkeletonsVisibleSound(this);
    c_qt = new RareSkeletonsQuestiontypes(this);
    c_l = new RareSkeletonsLibs(this);
    c_q = new RareSkeletonsQuestion(this);
}
